import { render, staticRenderFns } from "./goodsDialog.vue?vue&type=template&id=939e0230&scoped=true"
import script from "./goodsDialog.vue?vue&type=script&lang=js"
export * from "./goodsDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsDialog.vue?vue&type=style&index=0&id=939e0230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939e0230",
  null
  
)

export default component.exports